/* eslint-disable no-bitwise */
import styled from 'styled-components';

export const lightenDarkenColor = (col, amt) => {
  let usePound = false;

  if (col[0] === '#') {
    // eslint-disable-next-line no-param-reassign
    col = col.slice(1);
    usePound = true;
  }

  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  const newColor = (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
  return newColor;
};

export const Button = styled.button`
  display: inline-block;
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#e7e7e7')};
  color: ${(props) => (props.color ? props.color : '#000000')};
  height: 45px;
  width: ${(props) => props.width};
  font-size: 1em;
  font-weight: bold;
  text-transform: uppercase;
  padding: 7px 12px;
  border: 1px solid gray;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  :disabled,
  :disabled:hover {
    cursor: not-allowed;
    background-color: #e7e7e7;
    color: #666;
  }
  :focus {
    outline: none;
  }
  &:hover {
    background-color: ${(props) => lightenDarkenColor(
    props.bgColor ? props.bgColor : '#e7e7e7',
    props.bgVariance ? props.bgVariance : 20,
  )};
    color: ${(props) => (props.color ? props.color : '#000000')};
  }
  & i {
    padding-right: 5px;
    font-size: 1.2em;
  }
`;

export const GreenButton = styled(Button)`
  background-color: #008000;
  &:hover {
    background-color: ${lightenDarkenColor('#008000', 20)};
    color: white;
  }
`;

export const RedButton = styled(Button)`
  background-color: #DB2828;
  &:hover {
    background-color: ${lightenDarkenColor('#ff0000', 50)};
    color: #ffffff;
  }
`;
